export default "__VITE_ASSET__1xh8Z_mZ__ 480w, __VITE_ASSET__28qdTugV__ 768w, __VITE_ASSET__C1GxQ3_4__ 1200w, __VITE_ASSET__CZvP84ZZ__ 1600w";